import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatCard, MatCardHeader, MatCardTitle } from '@angular/material/card'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ProposalItemService } from '../../../../core/services/proposal/proposal-item/proposal-item.service'
import { PurchasesQuoteSupplierService } from '../../../../core/services/purchases/purchases-quote-supplier/purchases-quote-supplier.service'
import { ItinerariesService } from '../../../../core/services/itineraries/itineraries/itiniraries.service'
import { ErrorRequestModel } from '../../../../core/models/response.model'
import { convertCurrency } from '../../../../shared/utils/utils'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { CurrencyInputDirective } from '../../../../shared/directives/currencyInput'

@Component({
  selector: 'modal-purchases-discount-apply',
  imports: [
    MatProgressSpinner,
    ReactiveFormsModule,
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    CurrencyInputDirective,
  ],
  templateUrl: './modal-purchases-discount-apply.component.html',
  styleUrl: './modal-purchases-discount-apply.component.scss',
  standalone: true,
})
export class ModalPurchasesDiscountApplyComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private dialogRef: MatDialogRef<ModalPurchasesDiscountApplyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackbar: SnackbarCustomService,
    private proposalItemService: ProposalItemService,
    private purchasesQuoteSupplierService: PurchasesQuoteSupplierService,
    private itinerariesService: ItinerariesService,
  ) {
    this.itemPropostaId = data?.itemPropostaId
  }

  itemPropostaId: number
  item: any = {}
  paradas: any[] = []

  form: FormGroup = new FormGroup({})
  loading = false
  loadingItem = false

  @Output() response = new EventEmitter()

  ngOnInit(): void {
    this.createForm()
    this.getItem()
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      origin: [{ value: '', disabled: true }],
      destination: [{ value: '', disabled: true }],
      serviceType: [{ value: '', disabled: true }],
      service: [{ value: '', disabled: true }],
      vehicleType: [{ value: '', disabled: true }],
      driverType: [{ value: '', disabled: true }],
      dateStart: [{ value: '', disabled: true }],
      dateFinal: [{ value: '', disabled: true }],
      cost: ['', Validators.required],
      costKmExtra: ['', Validators.required],
      costOvertime: ['', Validators.required],
    })
  }

  getItem() {
    if (!this.itemPropostaId) {
      return
    }
    this.loadingItem = true
    this.proposalItemService.getProposalItembyId(this.itemPropostaId).subscribe({
      next: (response: any) => {
        this.item = response?.data ?? {}
        this.fillForm()
        this.loadParadas(this.itemPropostaId)
      },
      error: (err: ErrorRequestModel) => {
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loadingItem = false
      },
    })
  }

  // Paradas reais do item (só trechos intermediários 'P'). Origem e destino já
  // têm campos próprios no modal. Mesmo padrão do item edit form (loadParadasItemEdit).
  loadParadas(itemPropostaId: number) {
    this.itinerariesService
      .listPagedItinerariesStopByItemPropose(itemPropostaId, 1, 999)
      .subscribe({
        next: (resp: any) => {
          this.paradas = ((resp?.data ?? []) as any[])
            .filter((p) => (p.trecho ?? 'P') === 'P')
            .map((p, idx) => ({
              ...p,
              localParada: p.localParada ?? p.descricao ?? '',
              ordem: p.ordem ?? idx + 1,
            }))
            .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
        },
        error: () => {
          this.paradas = []
        },
      })
  }

  fillForm() {
    this.form.get('origin')?.setValue(this.item.origem)
    this.form.get('destination')?.setValue(this.item.destino)
    this.form.get('serviceType')?.setValue(this.item.descricaoTipoServico)
    this.form.get('service')?.setValue(this.item.descricaoServico)
    this.form.get('vehicleType')?.setValue(this.item.descricaoTipoVeiculo)
    this.form.get('driverType')?.setValue(this.item.descricaoTipoMotorista)
    this.form.get('dateStart')?.setValue(this.item.dataInicio)
    this.form.get('dateFinal')?.setValue(this.item.dataFinal)
    this.form.get('cost')?.setValue(convertCurrency(this.item.custo))
    this.form.get('costOvertime')?.setValue(convertCurrency(this.item.custoHoraExtra))
    this.form.get('costKmExtra')?.setValue(convertCurrency(this.item.custoKmExtra))
  }

  applyDiscount() {
    this.loading = true
    const model = this.createModel()
    this.purchasesQuoteSupplierService.applyDiscount(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  createModel() {
    return {
      itemPropostaId: this.itemPropostaId,
      custo: convertCurrency(this.form.get('cost')?.value),
      custoHoraExtra: convertCurrency(this.form.get('costOvertime')?.value),
      custoKmExtra: convertCurrency(this.form.get('costKmExtra')?.value),
    }
  }

  close() {
    this.dialogRef.close()
  }
}
